import { styled } from '@mui/material';

export const CommentSumaryContainer = styled('div')`
  padding: ${({ theme }) => theme.spacing(5, 0)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;
